/**
 * @file WorkplacePanel.tsx
 * @description Настройки рабочего места кладовщика (phase19.24 этап 1, шаг 1;
 * phase19.31 зона «Склад» — строка-переключатель кабинета, заголовок
 * страницы в верхней панели).
 *
 * Отличие от «Правил» и «Устройств»: здесь настройки ЭТОГО браузера, а не
 * склада. Они не уезжают на сервер и не касаются других сотрудников — телефон
 * на складе беззвучный, а компьютер в кабинете нет, и выбор принадлежит
 * устройству. Поэтому склада здесь не выбирают, а «Сохранить» нет —
 * переключатель применяется сразу.
 *
 * Пока настройка одна — звук и вибро при скане. Быстрый доступ остался в
 * меню «⋯» складского документа (`useScanSoundAction`). Вся строка — цель
 * касания: тап по любому месту переключает настройку.
 */

import { SETTINGS_CARD_CLASS, SettingSwitchRow } from "./SettingRows";
import { WmsSettingsHeader } from "./WmsSettingsHeader";
import { useScanFeedbackSetting } from "../../ui/useScanFeedbackSetting";

export function WorkplacePanel() {
  const { enabled, setEnabled } = useScanFeedbackSetting();

  return (
    <>
      <WmsSettingsHeader />
      <section aria-labelledby="workplace-title" className="flex max-w-[45rem] flex-col gap-2">
        <h2 id="workplace-title" className="type-section-title text-on-surface">
          Это устройство
        </h2>
        <p className="type-body text-on-surface-variant">
          Настройки этого телефона или компьютера: они не сохраняются на сервере и не влияют на других
          сотрудников магазина.
        </p>
        {/* SC69: строка настройки — на непрозрачной карточке. */}
        <div className={SETTINGS_CARD_CLASS}>
          <SettingSwitchRow
            label="Звук и вибрация при скане"
            hint="Короткий сигнал на удачный скан и длинный на ошибку — кладовщик не смотрит в экран во время обхода склада."
            checked={enabled}
            onChange={setEnabled}
          />
        </div>
      </section>
    </>
  );
}
